import {Component, OnInit} from '@angular/core';
import {Document} from '../documents/document-countries/document-countries.component';

@Component({
  selector: 'app-insurance',
  templateUrl: './insurance.component.html',
})
export class InsuranceComponent implements OnInit {
  countries: Array<Document> = [
    {
      countryName: 'Россия',
      img: 'ru.svg',
      docHref: 'insurance-conditions-zetta.html'
    },
    {
      countryName: 'Беларусь',
      img: 'by.svg',
      docHref: 'insurance-conditions-imkliva.html'
    },
  ];

  constructor() {
  }

  ngOnInit(): void {
  }

}
